import { Select } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import { companyFilterOptionsOf, useCompanies } from './companies.ts';
import { usePageContext } from './usePageContext.ts';

export type CompanyFilterProps = {
  api: TypedClient;
  company: string | null;
  onCompanyChange: (company: string | null) => void;
};

export const CompanyFilter = ({ api, company, onCompanyChange }: CompanyFilterProps) => {
  const { t } = usePageContext();
  const companies = useCompanies(api);
  if (companies.subsidiaries.length === 0) return null;
  return (
    <Select
      label={t('companies.label')}
      hideLabel
      value={company ?? ''}
      options={[{ value: '', label: t('companies.all') }, ...companyFilterOptionsOf(companies)]}
      onChange={(event) => {
        onCompanyChange(event.target.value === '' ? null : event.target.value);
      }}
    />
  );
};
